import React from 'react';
import Image from 'next/image';
import { STATIC_FILE_URL } from '@/shared/constants';
import { useConfigProvider, useCreateAccountProvider } from '@/lib/context';
import './index.less';

const MarkingMoneyBrand = ({ btnText = 'Explore Pietra Memberships' }) => {
  const { isMobile } = useConfigProvider();
  const { showSignupDialog } = useCreateAccountProvider();

  return (
    <div className="marking-money-brand">
      <div className="left-container">
        <p className="title">Make money for building your brand.</p>
        <p className="desc">
          Pietra rewards pays you back for sourcing products, shipping products, and selling products. Earns rewards to
          reinvest in your brand.
        </p>
        <span className="action-button" onClick={showSignupDialog}>
          {btnText}
        </span>
      </div>
      <div className="cash-back-image-container">
        <Image
          src={`${STATIC_FILE_URL}/7eb0cbb7a1970ebde2c8d91b635f88d0.png`}
          width={332}
          height={240}
          sizes="auto,(max-width:779.99px) 0px, (min-width:780px) 332px, 332px"
          style={{ borderRadius: 10, display: isMobile ? 'none' : '' }}
          alt="cash-back"
        />
      </div>
    </div>
  );
};

export default MarkingMoneyBrand;
